import { Injectable } from '@angular/core';
import { UserProfile } from '../_models/user-profile';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {
  private userProfile = new BehaviorSubject<UserProfile>(JSON.parse(localStorage.getItem("userProfile")));

  userProfile$ = this.userProfile.asObservable();

  constructor() { }

  getUserProfile() {
    const user = JSON.parse(localStorage.getItem("userProfile")) || null;
    if (user && (user != null) && (user != '')) { return user }
    // If no userProfile in localStorage:
    return null;
  }

  updateProfile(newProfile: UserProfile) {
    localStorage.setItem("userProfile", JSON.stringify(newProfile));
    this.userProfile.next(newProfile);
  }
}
